var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33337 8.00008C2.96518 8.00008 2.66671 8.29856 2.66671 8.66675V13.3334C2.66671 13.7016 2.96518 14.0001 3.33337 14.0001H12.6667C13.0349 14.0001 13.3334 13.7016 13.3334 13.3334V8.66675C13.3334 8.29856 13.0349 8.00008 12.6667 8.00008H3.33337ZM1.33337 8.66675C1.33337 7.56218 2.2288 6.66675 3.33337 6.66675H12.6667C13.7713 6.66675 14.6667 7.56218 14.6667 8.66675V13.3334C14.6667 14.438 13.7713 15.3334 12.6667 15.3334H3.33337C2.2288 15.3334 1.33337 14.438 1.33337 13.3334V8.66675Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00004 2.00008C7.2928 2.00008 6.61452 2.28103 6.11442 2.78113C5.61433 3.28123 5.33337 3.9595 5.33337 4.66675V7.33342C5.33337 7.7016 5.0349 8.00008 4.66671 8.00008C4.29852 8.00008 4.00004 7.7016 4.00004 7.33342V4.66675C4.00004 3.60588 4.42147 2.58847 5.17161 1.83832C5.92176 1.08818 6.93917 0.666748 8.00004 0.666748C9.06091 0.666748 10.0783 1.08818 10.8285 1.83832C11.5786 2.58847 12 3.60588 12 4.66675V7.33342C12 7.7016 11.7016 8.00008 11.3334 8.00008C10.9652 8.00008 10.6667 7.7016 10.6667 7.33342V4.66675C10.6667 3.9595 10.3858 3.28123 9.88566 2.78113C9.38556 2.28103 8.70728 2.00008 8.00004 2.00008Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.0064f7c0b2a2c411889049ef24abc5c3.svg";
export { ForwardRef as ReactComponent };